import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const Motion = styled(motion.div)`
  overflow: hidden;
`;
